<script>
import { defineAsyncComponent } from 'vue';
import "@common/syncfusionCss";
import { configStore } from "@common/configStore";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import headerImage from '@components/vms/assets/Samaritan-header-mobile.png';
import { controlStore, createStoreIndex } from "@common/control/controlStore";

const controlComponent = defineAsyncComponent(() => import('@common/control/control.vue'));

const editorSettings = {};

let vmsCfg = {
    cId: "vms",
    cType: "vms",
    cTitle: "VMS",
    cTemplate: `<div oncontextmenu="return false" class="main-grid-wrapper">
                    <div class="main-grid-appbar">
                        <ejs-appbar>
                            <img :src="headerImage" alt="Samaritan" class="header-image" />
                            <div class="e-appbar-spacer"></div>
                            <control name="HELP_MENU" :items="helpMenu"></control>
                            <control name="USER_MENU" :items="userMenu" :label="userStore.coordinator.CLIENT_USER_NAME"></control>
                        </ejs-appbar>
                    </div>
                    <ejs-sidebar
                        :enableDock='true'
                        :dockSize="'80px'"
                        :enableGestures="false"
                        :width="'200px'"
                        :target="'.main-grid-main-content-wrapper'"
                        :mediaQuery="'(min-width: 600px)'"
                        ref="leftSidebar"
                        @open="leftPanelOpened = !leftPanelOpened"
                        @close="leftPanelOpened = !leftPanelOpened"
                    >
                        <div class="panel">
                            <div class="panel-section">
                                <div v-for="(control, index) in leftMenu['main']" :key="index">
                                    <control :name="control.name" :label="leftPanelOpened ? control.label : ''"></control>
                                </div>
                            </div>
                            <hr class="panel-separator">
                            <div class="panel-section">
                                <h4 v-if="leftPanelOpened">Data Management</h4>
                                <div v-for="(control, index) in leftMenu['dataManagement']" :key="index">
                                    <control :name="control.name" :label="leftPanelOpened ? control.label : ''"></control>
                                </div>
                            </div>
                            <hr class="panel-separator">
                            <div class="panel-section">
                                <h4 v-if="leftPanelOpened">Functional Features</h4>
                                <div v-for="(control, index) in leftMenu['functionalFeatures']" :key="index">
                                    <control :name="control.name" :label="leftPanelOpened ? control.label : ''"></control>
                                </div>
                            </div>
                            <hr class="panel-separator">
                            <div class="panel-section">
                                <h4 v-if="leftPanelOpened">Admin Options</h4>
                                <div v-for="(control, index) in leftMenu['admin']" :key="index">
                                    <control :name="control.name" :label="leftPanelOpened ? control.label : ''"></control>
                                </div>
                            </div>
                        </div>
                        <span v-if="leftPanelOpened" class="toggle-panel opened fa fa-arrow-left-long-to-line" @click="togglePanel"></span>
                        <span v-else class="toggle-panel fa fa-arrow-right-long-to-line" @click="togglePanel"></span>
                    </ejs-sidebar>
                    <div class="main-grid-main-content-wrapper">
                        <div class="main-grid-content">
                            <!--<control name="ICON_PICKER" :prop-config="{type: 'iconpicker', name: 'ICON_PICKER'}"></control>-->
                            <vms-main-grid v-if="psp && psp !== 'dashboard'" c-id="vmsMainGrid" :prop-psp="psp"></vms-main-grid>
                            <layout-container v-if="psp === 'dashboard'" :c-id="accountSettings.ACCOUNT_EC_DASHBOARD_ID"></layout-container>
                        </div>
                        <div class="main-grid-right-sidebar"></div>
                    </div>
                </div>
                `,
    controls: [
        {
            name: 'HELP_MENU',
            type: 'dropdownbutton',
            iconCss: 'fa-regular fa-circle-question',
            cssClass: 'e-caret-hide',
            width: '28px'
        },
        {
            name: 'USER_MENU',
            type: 'dropdownbutton',
            iconCss: 'fa-regular fa-user',
            width: 'fit-content',
            onbeforeitemrender: 'onBeforeItemRender'
        }
    ]
};

const vmsCmp = {
    name: 'vms',
    preInitControls: true,
    editorSettings: editorSettings,
    props: {},
    data() {
        return {
            psp: false,
            selectedRecords: false,
            ddLoading: true,
            leftMenu: {},
            userMenu: [],
            helpMenu: [],
            headerImage: headerImage,
            leftPanelOpened: true,
            selectedTab: false,
            icons: {
                'COORD_AFF': 'fa-regular fa-grid-2',
                'COORD_DASHBOARD': 'fa-regular fa-chart-tree-map',
                'COORD_VOL': 'fa-regular fa-user',
                'COORD_OPP': 'fa-regular fa-cube',
                'COORD_AE': 'fa-regular fa-clipboard-list-check',
                'COORD_ORG': 'fa-regular fa-building-memo',
                'COORD_MEM': 'fa-regular fa-people-group',
                'COORD_CALENDAR': 'fa-regular fa-calendar',
                'COORD_EMAIL': 'fa-regular fa-envelope',
                'COORD_AUTOMATION': 'fa-regular fa-gears',
                'COORD_ADMIN_OPTIONS': 'fa-regular fa-sliders',
                'COORD_TOOLS': 'fa-regular fa-star-sharp'
            }
        };
    },
    computed: {
    },
    methods: {
        togglePanel() {
            if (this?.$refs?.['leftSidebar']?.ej2Instances?.toggle) this.$refs['leftSidebar'].ej2Instances.toggle();
            // @todo add save to client property
        },
        getPspByAbbrev(abbrev) {
            let psp;
            abbrev = abbrev.toLowerCase();
            switch (abbrev) {
                case 'vol':
                    psp = 1;
                    break;
                case 'opp':
                    psp = 2;
                    break;
                case 'org':
                    psp = 3;
                    break;
                case 'mem':
                    psp = 5;
                    break;
                case 'ae':
                    psp = 8;
                    break;
                case 'aff':
                    psp = 32;
                    break;
                case 'dashboard':
                    psp = 'dashboard';
                    break;
            }
            return psp;
        },
        processTab(ev, button) {
            let tmpPsp = this.getPspByAbbrev(button?.name?.replace('COORD_', ''));
            if (tmpPsp) {
                this.selectedTab = false;
                this.psp = false;
                this.$nextTick(() => {
                    this.selectedTab = button.name;
                    this.psp = tmpPsp;
                });
            }
        },
        onDropdownButtonOpen(args) {
            if (args?.element?.parentElement?.style) {
                args.element.parentElement.style.left = this.leftPanelOpened ? '210px' : '90px';
                args.element.style['border-radius'] = '10px';
            }
        },
        async onLoad() {
            this.ffList = await configStore.getAllClientFFList();
            let addControl = (controlToAdd, disabled) => {
                let tmpControl = {};
                let isDropdownButton = controlToAdd?.items?.length;
                tmpControl.type = isDropdownButton ? 'dropdownbutton' : 'button';
                if (isDropdownButton) {
                    tmpControl.items = controlToAdd.items;
                    tmpControl.fields = { text: 'text', value: 'value' };
                    tmpControl.onopen = 'onDropdownButtonOpen';
                    tmpControl.caretCss = 'fa-regular fa-angle-right';
                }
                tmpControl.label = controlToAdd.text;
                tmpControl.title = controlToAdd.text;
                tmpControl.name = controlToAdd.value;
                tmpControl.disabled = disabled || false;
                tmpControl.cssClass = 'e-flat';
                if (!disabled) tmpControl.onclick = 'processTab';
                if (this.icons[tmpControl.name]) {
                    tmpControl.iconCss = this.icons[tmpControl.name];
                }
                let controlStoreIndex = createStoreIndex(this.storeId, tmpControl.name);
                if (typeof this.controlConfigs === 'undefined') this.controlConfigs = {};
                this.controlConfigs[tmpControl.name] = tmpControl;
                controlStore().addControl(tmpControl, this, controlStoreIndex);
                return tmpControl;
            };
            if (this.ffList.COORDINATOR) {
                let main = ['COORD_DASHBOARD', 'COORD_AFF'];
                let dataManagement = ['COORD_VOL', 'COORD_OPP', 'COORD_AE', 'COORD_ORG', 'COORD_MEM'];
                for (let i in this.ffList.COORDINATOR) {
                    if (main.indexOf(this.ffList.COORDINATOR[i].value) !== -1) {
                        if (typeof this.leftMenu['main'] === 'undefined') this.leftMenu['main'] = [];
                        this.leftMenu['main'].push(addControl(this.ffList.COORDINATOR[i]));
                    }
                    if (dataManagement.indexOf(this.ffList.COORDINATOR[i].value) !== -1) {
                        if (typeof this.leftMenu['dataManagement'] === 'undefined') this.leftMenu['dataManagement'] = [];
                        this.leftMenu['dataManagement'].push(addControl(this.ffList.COORDINATOR[i]));
                    }
                }
            }
            /* functional features */
            if (typeof this.leftMenu['functionalFeatures'] === 'undefined') this.leftMenu['functionalFeatures'] = [];
            this.leftMenu['functionalFeatures'].push(addControl({
                text: 'Calendar',
                value: 'COORD_CALENDAR'
            }, true));
            this.leftMenu['functionalFeatures'].push(addControl({
                text: 'Email',
                value: 'COORD_EMAIL'
            }, true));
            this.leftMenu['functionalFeatures'].push(addControl({
                text: 'Automations',
                value: 'COORD_AUTOMATION'
            }, true));

            if (this.ffList.ADMIN_OPTION) {
                let tools = ['ADM_SURVEY', 'ADM_WAIVER', 'ADM_TRAINING', 'ADM_PDFTEMPLATES', 'ADM_FAQ_PAGE', 'ADM_WORKFLOWS'];
                let toolsItems = [];
                let adminItems = [];
                for (let i in this.ffList.ADMIN_OPTION) {
                    if (tools.indexOf(this.ffList.ADMIN_OPTION[i].value) !== -1) {
                        toolsItems.push(this.ffList.ADMIN_OPTION[i]);
                    } else {
                        adminItems.push(this.ffList.ADMIN_OPTION[i]);
                    }
                }
                if (typeof this.leftMenu['admin'] === 'undefined') this.leftMenu['admin'] = [];
                if (adminItems.length) {
                    this.leftMenu['admin'].push(addControl({
                        text: 'Admin Options',
                        value: 'COORD_ADMIN_OPTIONS',
                        items: adminItems
                    }));
                }
                if (toolsItems.length) {
                    this.leftMenu['admin'].push(addControl({
                        text: 'Tools',
                        value: 'COORD_TOOLS',
                        items: toolsItems
                    }));
                }
            }
            let response = await this.sDs.post('ec_getMainGridInfo', 1, ['menu']);
            if (response && response.status === 'success' && response.data && response.data.menu) {
                let tmpUserMenu = response.data.menu.find((tmp) => tmp.name === 'M_ACCOUNT');
                if (Array.isArray(tmpUserMenu?.items)) {
                    tmpUserMenu.items.forEach((item) => {
                        item.text = item.title;
                        item.value = item.name;
                        item.iconCss = 'fa-regular fa-star';
                    });
                    let userName = this.userStore.coordinator.CLIENT_USER_NAME;
                    let userEmail = this.userStore.coordinator.CLIENT_EMAIL;
                    this.userMenu = [
                        ...[
                            { template: '<div><span class="e-btn-icon fa-regular fa-user"></span></div><div><div>' + userName + '</div><div>' + userEmail + '</div></div>', height: '80px' },
                            { separator: true, text: '' }
                        ],
                        ...library.cloneObj(tmpUserMenu.items)
                    ];
                }
                let tmpHelpMenu = response.data.menu.find((tmp) => tmp.name === 'M_HELP');
                if (Array.isArray(tmpHelpMenu?.items)) {
                    tmpHelpMenu.items.forEach((item) => {
                        item.text = item.ITEM_TITLE;
                        item.value = item.action;
                        item.url = item.ITEM_URL;
                        item.iconCss = 'fa-regular fa-up-right-from-square';
                    });
                    this.helpMenu = library.cloneObj(tmpHelpMenu.items);
                }
                let tmpToolsMenu = response.data.menu.find((tmp) => tmp.name === 'M_TOOLS');
                if (tmpToolsMenu) {
                    this.leftMenu['tools'] = library.cloneObj(tmpToolsMenu.items);
                }
                // this.prepareMenuItems(response.data.menu);
            }
            this.psp = 32;
            /* window.addEventListener('resize', this.resizeHeight, true);
            this.resizeHeight();
            this.ddLoading = true;
            await ddStore.preloadGroup('COMMON');
            await ddStore.preloadGroup('DATA_GRID');
            this.ddLoading = false;
            this.findButtonLabel = await ddStore.getAlias('COMMON', 'BUTTON_FIND');
            let abbrev = configStore.pspParentNamesAbbrev[this.psp];
            if (abbrev) {
                configStore.getEcUserProperty(abbrev.toUpperCase() + '_showEntitiesSummary').then((response) => {
                    this.showEntitiesSummary = !!response;
                });
            }
            this.reloadGrid(); */
        },

    },
    components: {
        menuBar: defineAsyncComponent(() => import('@common/menuBar.vue')),
        'ejs-appbar': defineAsyncComponent(() => import('@common/syncfusion/appBar.vue')),
        'ejs-sidebar': defineAsyncComponent(() => import('@common/syncfusion/sidebar.vue')),
        'ejs-tooltip': defineAsyncComponent(() => import('@common/syncfusion/tooltip')),
        "ejs-dropdownbutton": defineAsyncComponent(() => import('@common/syncfusion/dropdownButton')),
    }
};

componentStore.initComponent(vmsCmp, vmsCfg);
export { vmsCfg, vmsCmp };
export default vmsCmp;
</script>

<style lang="css">
@import "~@common/global.css";
@import "~@common/styles/utilities.css";
</style>

<style scoped>
:deep(.main-grid-wrapper) {
    display: flex;
    flex-direction: column;
    height: 100vh;
}
:deep(.main-grid-main-content-wrapper) {
    flex-grow: 12;
}
:deep(.header-image) {
    height: 40px;
    width: auto;
    object-fit: contain;
}
:deep(.panel) {
    padding: 10px;
}
:deep(.panel button) {
    text-align: left;
    text-transform: none;
    font-weight: 500;
    font-size: 13px;
    color: rgb(67, 67, 67);
}
:deep(.panel button .e-btn-icon) {
    font-size: 20px;
    color: rgb(67, 67, 67);
    width: 30px;
    margin-left: 0;
    text-align: center;
    font-weight: 300;
}
:deep(.panel-section) {
    /*margin-bottom: 30px;*/
}

:deep(.panel-section > div) {
    margin-top: 5px;
    margin-bottom: 5px;
}

:deep(.panel-section h4) {
    /*font-size: 1.1em;*/
    margin: 0 0 10px 0;
    color: #959595;
}
:deep(.toggle-panel) {
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 22px;
    font-weight: 300;
    color: #959595;
    position: absolute;
    bottom: 10px;
    margin: 0 auto;
    display: block;
    left: 0;
    right: 0;
}

:deep(.toggle-panel.opened) {
    right: 10px;
    margin: unset;
    left: unset;
}

:deep(hr.panel-separator) {
    border: none;
    height: 1px;
    background-color: #959595;
    margin: 20px 0;
}
:deep(.main-grid-content) {
    padding: 10px;
}

:deep(.main-grid-content button) {
    text-transform: none;
}
</style>
